import { Box } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useAPI from "../../../../api/hooks/useAPI";
import { vulnerabilityKeys } from "../../../../api/queryKeys";
import LoadingIcon from "../../../../components/LoadingIcon";
import { daysPastSince } from "../../../../utils/timestamp";
import VulnerabilitiesTable from "../../vulnerabilities/VulnerabilitiesTable";

const MitigationVulnerabilitiesTable = ({
  vulnerabilityIds,
  onRowClick,
  title = "",
}) => {
  const { fetchVulnerabilitiesBatch } = useAPI();
  const {
    data: mitigationVulnerabilities,
    isLoading: mitigationVulnerabilitiesIsLoading,
  } = useQuery({
    queryKey: vulnerabilityKeys.batchVulnerabilities(vulnerabilityIds),
    queryFn: () => {
      return fetchVulnerabilitiesBatch(vulnerabilityIds);
    },
    select: (response) =>
      response.data.map((vuln) => ({
        ...vuln,
        id: vuln.vulnerability_id,
        days_found: daysPastSince(
          vuln.published_date?.timestamp_utc_human_readable
        ),
      })),
    enabled: vulnerabilityIds?.length > 0,
  });

  return mitigationVulnerabilities?.length > 0 ? (
    <Box>
      <VulnerabilitiesTable
        dataIsLoading={mitigationVulnerabilitiesIsLoading}
        vulnerabilities={mitigationVulnerabilities}
        gridRef={null}
        onRowClick={(row) => onRowClick(row)}
        filterColumns={[
          "vulnerability_id",
          "breeze_score",
          "severity",
          "exploit",
          "published_date",
        ]}
        pageSizeOptionsOverride={[5, 10, 20]}
      />
    </Box>
  ) : mitigationVulnerabilitiesIsLoading ? (
    <LoadingIcon />
  ) : null;
};

export default MitigationVulnerabilitiesTable;
